import { 
  TextField, 
  InputAdornment, 
  IconButton, 
  FormHelperText, 
  FormControl 
} from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

/**
 * Reusable input field component with clear button and error handling
 */
export default function InputField({
  label,
  placeholder,
  value = '',
  onChange,
  error,
  helperText,
  fullWidth = true,
  required = false,
  disabled = false,
  type = 'text',
  variant = 'outlined',
  size = 'medium',
  multiline = false,
  rows = 1,
  maxRows,
  sx = {},
  clearable = true,
  InputProps = {},
  ...props
}) {
  // Handle change events
  const handleChange = (e) => {
    if (onChange) {
      onChange(e);
    }
  };

  // Handle clear button click
  const handleClear = () => {
    if (onChange) {
      onChange({ target: { value: '' } });
    }
  };

  // Get clear button if needed
  const getClearButton = () => {
    if (!clearable || !value) return null;
    
    return (
      <InputAdornment position="end">
        <IconButton
          edge="end"
          onClick={handleClear}
          size="small"
          aria-label="clear input"
        >
          <ClearIcon fontSize="small" />
        </IconButton>
      </InputAdornment>
    );
  };

  // Merge any provided InputProps with our clear button
  const mergedInputProps = {
    ...InputProps,
    endAdornment: (
      <>
        {getClearButton()}
        {InputProps.endAdornment}
      </>
    ),
  };

  return (
    <FormControl fullWidth={fullWidth} error={!!error} sx={sx}>
      <TextField
        label={label}
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        error={!!error}
        helperText={helperText}
        required={required}
        disabled={disabled}
        type={type}
        variant={variant}
        size={size}
        multiline={multiline}
        rows={rows}
        maxRows={maxRows}
        InputProps={mergedInputProps}
        {...props}
      />
      {error && !helperText && (
        <FormHelperText error>{error}</FormHelperText>
      )}
    </FormControl>
  );
} 